import { isRejected, type Middleware } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'

// Expected failures, not worth reporting
const IGNORED_CODES = [
  // login and re-auth
  'auth/invalid-credential', 'auth/wrong-password', 'auth/user-not-found', 'auth/invalid-email',
  'auth/missing-password', 'auth/user-disabled', 'auth/user-mismatch', 'auth/too-many-requests',
  // callable business-rule rejections
  'functions/invalid-argument', 'functions/failed-precondition', 'functions/unauthenticated',
  // network noise
  'auth/network-request-failed', 'functions/unavailable', 'functions/deadline-exceeded', 'unavailable',
]

// These forward raw Stripe and Admin SDK text, so leave the message out
const REDACTED_CODES = ['functions/internal', 'functions/unknown']

type ErrorPayload = { status?: string | number; data?: { message?: string } }
type RejectedMeta = { arg?: { endpointName?: string } }

export const sentryMiddleware: Middleware = () => next => action => {
  if (isRejected(action) && !action.meta?.condition && !action.meta?.aborted) {
    const payload = action.payload as ErrorPayload | undefined
    const status = String(payload?.status ?? 'unknown')

    if (!IGNORED_CODES.includes(status)) {
      const endpoint = (action.meta as RejectedMeta)?.arg?.endpointName ?? 'unknown'
      const message = REDACTED_CODES.includes(status) ? undefined : payload?.data?.message ?? action.error?.message

      Sentry.captureMessage(`${ endpoint } failed: ${ status }`, {
        level: 'error',
        tags: { endpoint },
        fingerprint: [endpoint, status],
        extra: { status, message },
      })
    }
  }
  return next(action)
}
